export const getThankYouTypeFromData = (thankYou) => {
    const thankYouData = thankYou.thankYous[0];
    if (thankYouData?.mediaType.type === 'video')
        return 'VIDEO';
    if (thankYouData?.mediaType.type === 'audio')
        return 'AUDIO';
    if (thankYouData?.mediaType.type === 'image')
        return 'IMAGE';
    // default
    return 'VIDEO';
};
